<template>
  <el-dialog :title="title" :visible.sync="operatorDialogOpen" width="500px" append-to-body :destroy-on-close="true" @close="resetForm">
    <el-form ref="form" :model="form" :rules="closeOrderFormRule">
      <el-form-item prop="content">
        <el-input type="textarea" :rows="4" v-model="form.content" :placeholder="closeOrderFormRule.content[0].message" ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="mini" type="text"  @click="operatorDialogOpen = false"> 取消 </el-button>
      <el-button size="mini" v-re-click type="primary"  @click="handleCloseOrderConfirm"> 确认 </el-button>
    </div>
  </el-dialog>
</template>
<script>

export default {
  props:{
    title:{
      type: String,
    },
    placeholder:{
      type: String,
    },
    closeOrderFormRule: {
      type: Object,
      default: () => ({ content: [{required: true, message: '请输入关闭原因'}] })
    },
  },
  data(){
    return {
      form: {
        content: ''
      },
      operatorDialogOpen: false,
    }
  },
  filters:{
    operationTypeToText(val) {
      let map = {
        0: "创建工单",
        1: "提交处理记录",
        2: "关闭工单"
      };
      return map[val];
    },
  },
  methods:{
    resetForm(){
      this.form = {
        content: ''
      }
    },
    handleCloseOrderConfirm(){
      this.$refs.form.validate((valid)=>{
        if(valid) this.$emit('handleConfirm', this.form.content)
      })
      
    },
  }
}
</script>
